// extracted by mini-css-extract-plugin
module.exports = {"jcGrey800":"#202d38","text":"ImportStatus__text","new":"ImportStatus__new","imported":"ImportStatus__imported"};